import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for Bluetooth printer state (Android only)
 * Manages available devices, selected printer, and paper size
 */
const BluetoothSlice = createSlice({
  name: 'bluetooth',
  initialState: {
    bluetooth_devices: [],
    selected_bluetooth_device: null,
    paper_size: null,
    error: null,
  },
  reducers: {
    /** Sets list of available Bluetooth devices */
    setBluetoothDevices(state, action) {
      state.bluetooth_devices = action.payload;
    },
    /** Sets selected Bluetooth printer device */
    setSelectedBluetoothDevice(state, action) {
      state.selected_bluetooth_device = action.payload;
    },
    /** Sets thermal printer paper size (58mm/80mm) */
    setPaperSize(state, action) {
      state.paper_size = action.payload;
    },
  },
});

export const { setBluetoothDevices, setSelectedBluetoothDevice, setPaperSize } =
  BluetoothSlice.actions;
export default BluetoothSlice.reducer;
